module.exports = __webpack_public_path__ + "static/media/website_weap.acc23a25.png";